import { EpimsBaseEntityDto } from './epim-base.dto';
import { SeismicClaimantRefDto } from '@cradua/data';
export class DamageAssessmentDto extends EpimsBaseEntityDto {
  
    
    DamageRefNo: string;
    CouponNo: string;
    ContractorId: string;
    ContractorName: string;
    CrewId: string;
    CrewName: string;
    ProgrammeId: string;
    ProgrammeName: string;
    AssessmentDate: Date;
    OMLId: string;
    OMLName: string;
    ClaimTypeId: string;
    ClaimTypeName: string;
    CountryId: string;
    CountryName: string;
    StateId: string;
    StateName: string;
    LGAId: string;
    LGAName: string;
    AccessorId: string;
    AccessorName: string;
    Totals: number;
    AmountPaid: number;
    SwathId: string;
    SwathNo: string;
    LineTypeId: string;
    LineTypeName: string;
    LineNumber: string;
    DivisionId: string;
    DivisionName: string;
    Comments: string;
    Status: string;
    Archived: string;
    NoOfApprovals: string;
    PrintedStatus: string;
    DocumentRefNo: string;
    Representatives: string;
    VillageName: string;
    InterpreterName: string;
    WitnessName: string;
    WitnessAddress: string;
    WitnessPhone: string;
    CommunityId: string;
    CommunityName: string;
    SubscriptionUserId: string;  
    Version: number;
    CurrencyCode: string;
    CurrencyName: string;
    VillageId: string;
    ReceiverId: string;
    StaffId: string;
    IsChecked: boolean;
    FinalApprovalPersonId: string;
    FinalApprovalPersonName: string;
    FinalApprovalPersonRemarks: string;
    FinalApprovalDate: Date;
    ApprovalTrackingNo: string;
    Remarks: string;
    ReceiverEmail: string;
    IsReSubmitted: boolean;
    ReSubmittedBy: string;
    ClaimantName: string;
    ApprovalComments: string;

}
